import { createApi } from "@reduxjs/toolkit/query/react";
import { reducerPaths } from "../../app/reducerPaths";
import { baseQueryWithAuth } from "../methods/baseQueryWithAuth";

export const buyNowApi = createApi({
  reducerPath: reducerPaths.buyNowApi, // Unique key in Redux store
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getBuyNowVehicles: builder.query({
      query: ({ method, params }) => ({
        url: `/myGarage/Dealer/BuyNow`,
        method: "GET",
        params: params || {},
      }),
    }),
    getOwnBuyNowVehicles: builder.query({
      query: ({ method, params }) => ({
        url: `/myGarage/Seller/BuyNow`,
        method: "GET",
        params: params || {},
      }),
    }),
    buyNow: builder.query({
      query: ({ Vehicle_Id }) => {
        return {
          method: "GET",
          url: `/buynow/${Vehicle_Id}`
        }
      }
    }),
    getBuyNowTimeoutDetails: builder.query({
      query: ({ Vehicle_Id }) => {
        return {
          method: "GET",
          url: `/buynowtimeoutdetails/${Vehicle_Id}`,
        }
      }
    }),
    setBidPriceBuyNow: builder.mutation({
      query: ({ payload }) => {
        return {
          method: "POST",
          url: `/dealer/place_bid_buynow`,
          body: payload
        }
      }
    }),
  }),
});

export const {
  useSetBidPriceBuyNowMutation,
  useLazyGetBuyNowVehiclesQuery,
  useLazyGetOwnBuyNowVehiclesQuery,
  useLazyGetBuyNowTimeoutDetailsQuery,
  useLazyBuyNowQuery
} = buyNowApi;
